import React from 'react';

import LoadingComponent from '@/components/templates/LoadingComponent';

import ConsultantsTable from './components/ConsultantsTable';
import DashboardFilters from './components/DashboardFilters';
import NoVisitReasonsChart from './components/NoVisitReasonsChart';
import ReportsChart from './components/ReportsChart';
import ReportsTable from './components/ReportsTable';
import VisitProfileChart from './components/VisitProfileChart';
import { useReportsDashboard } from './hooks';
import { Container, CardsGrid, Card, CardTitle, CardValue, ChartsRow, ChartsRowSmall } from './styles';

const ReportsDashboard = ({ idEnterprise }) => {
    const {
        isLoading,
        dashboardData,
        filters,
        tempFilters,
        cards,
        years,
        cycles,
        consultants,
        reportsTable,
        reportsTablePage,
        reportsTablePerPage,
        consultantsTable,
        consultantsTablePage,
        consultantsTablePerPage,
        handleTempFilterChange,
        handleApplyFilters,
        handleClearFilters,
        handleReportsTablePageChange,
        handleReportsTablePerPageChange,
        handleConsultantsTablePageChange,
        handleConsultantsTablePerPageChange
    } = useReportsDashboard(idEnterprise);

    if (isLoading && !dashboardData) {
        return <LoadingComponent hideLogo />;
    }

    return (
        <Container>
            <DashboardFilters
                years={years}
                cycles={cycles}
                consultants={consultants}
                tempFilters={tempFilters}
                onFilterChange={handleTempFilterChange}
                onApply={handleApplyFilters}
                onClear={handleClearFilters}
            />

            <CardsGrid>
                <Card>
                    <CardTitle>Fazendas ativas</CardTitle>
                    <CardValue>{cards.activeFarms || 0}</CardValue>
                </Card>

                <Card>
                    <CardTitle>Visitas previstas</CardTitle>
                    <CardValue>{cards.visitsPlanned || 0}</CardValue>
                </Card>

                <Card>
                    <CardTitle>Visitas realizadas</CardTitle>
                    <CardValue>{cards.visitsRealized || 0}</CardValue>
                </Card>

                <Card>
                    <CardTitle>Relatório aprovados</CardTitle>
                    <CardValue>{cards.approvedReports || 0}</CardValue>
                </Card>

                <Card>
                    <CardTitle>Relatório pendentes</CardTitle>
                    <CardValue>{cards.pendingReports || 0}</CardValue>
                </Card>
            </CardsGrid>

            <ChartsRow>
                <ReportsChart
                    data={dashboardData?.chartData?.months}
                    year={tempFilters.year}
                    totalApproved={dashboardData?.chartData?.totalApproved || 0}
                />
            </ChartsRow>

            <ChartsRowSmall>
                <NoVisitReasonsChart data={dashboardData?.noVisitReasons} />
                <VisitProfileChart data={dashboardData?.visitProfile} />
            </ChartsRowSmall>

            <ReportsTable
                data={reportsTable.data}
                total={reportsTable.total}
                page={reportsTablePage}
                perPage={reportsTablePerPage}
                lastPage={reportsTable.lastPage}
                onPageChange={handleReportsTablePageChange}
                onPerPageChange={handleReportsTablePerPageChange}
                enterpriseId={idEnterprise}
                filters={filters}
                isLoading={isLoading}
                cycles={cycles}
            />

            <ConsultantsTable
                data={consultantsTable.data}
                total={consultantsTable.total}
                page={consultantsTablePage}
                perPage={consultantsTablePerPage}
                lastPage={consultantsTable.lastPage}
                onPageChange={handleConsultantsTablePageChange}
                onPerPageChange={handleConsultantsTablePerPageChange}
                enterpriseId={idEnterprise}
                filters={filters}
                cycles={cycles}
            />
        </Container>
    );
};

export default ReportsDashboard;
